
import { useState } from "react";
import { useUserDataContext } from '../../contexts/userDataProvider';
import userAPI from '../../services/userAPI';
import { useEdit } from '../common/requests.hooks';
import Loader from '../common/Loader';
import ErrorAlert from '../common/ErrorAlert';
import ChangeLanguage from './ChangeLanguage';
import SetFeeding from './SetFeeding';
import AddCoworkers from './coworkers/AddCoworkers';
import CoworkerAcceptedRequest from './coworkers/CoworkerAcceptedRequest';

const UserSettings = ({
  setIsSidePannelLoading,
  setSidePannelError,
  isApprovedCoworker,
  workSpaceEmail,
  workSpaceId
}) => {
  // TODO: Test This:
  const [settingsToSave, setSettingsToSave] = useState({}); // { selectedLocale: locale }

  const { translate, data: userData, reloadData } = useUserDataContext();

  const {
    selectedLocale,
    isDisplayFeedingOption,
    nickname
  } = userData ? userData[0] : '';

  const { isLoading, error, sendEditDataRequest } = useEdit(
    (data) => userAPI.editUser(data),
    {
      onSuccess: () => reloadData()
    }
  );

  const handleSaveEditData = (itemToSave) => {
    setSettingsToSave(itemToSave)
    sendEditDataRequest(itemToSave);
  };

  return (
    <div className="user-settings-wrap">
      <Loader 
        setIsLoading={isLoading}
      />
      <ErrorAlert
        error={error}
      />
      <h5>{translate('userSettings')}</h5>
      <ChangeLanguage
        selectedLocale={selectedLocale}
        handleSaveEditData={handleSaveEditData}
        translate={translate}
      />
      <SetFeeding
        isDisplayFeedingOption={isDisplayFeedingOption}
        handleSaveEditData={handleSaveEditData}
        translate={translate}
      />
      {isApprovedCoworker ? (
        <>
          <h5>{translate('acceptedWorkspaceAccess')}</h5>
          <CoworkerAcceptedRequest
            translate={translate}
            workSpaceEmail={workSpaceEmail}
            workSpaceId={workSpaceId}
            setIsLoading={setIsSidePannelLoading}
            setError={setSidePannelError}
          />
        </>
      ) : (
        <>
          <h5>{translate('grantAccess')}</h5>
          <AddCoworkers
            nickname={nickname} // Nickname is used because it is short and part of email
            translate={translate}
            setIsLoading={setIsSidePannelLoading}
            setError={setSidePannelError}
          />
        </>
      )}
    </div>
  );
};

export default UserSettings;
